import type { Route } from '@angular/router';
import { LayoutComponent, LayoutOption } from 'app/layout/layout.component';

export const publicRoutes: Route[] = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'sign-out',
        data: {
          layout: LayoutOption.Empty,
        },
        loadComponent: () => import('app/modules/auth/sign-out/sign-out.component').then((m) => m.AuthSignOutComponent),
      },
      {
        path: 'patient-form',
        data: {
          layout: LayoutOption.PatientForm,
        },
        loadComponent: () => import('./patient-form-page/patient-form-page').then((m) => m.PatientFormPage),
      },
      {
        path: 'patient-form-success',
        data: {
          layout: LayoutOption.Empty,
        },
        loadComponent: () =>
          import('./patient-form-success-page/patient-form-success-page').then((m) => m.PatientFormSuccessPage),
      },
      {
        // Formsort prefill bridge. Public (no MSAL guard) because it is opened in a new
        // tab whose sessionStorage has no MSAL session; it authenticates with the JWT
        // passed on the URL instead. Keep the path in sync with `buildClinicalFormUrl`.
        path: 'clinical-data/open-form/:clinicianSurveyId',
        data: {
          layout: LayoutOption.Empty,
        },
        loadComponent: () =>
          import('app/modules/admin/clinical-data/open-form/open-clinical-form.component').then(
            (m) => m.OpenClinicalFormComponent
          ),
      },
    ],
  },
];
